import Cookies from 'js-cookie';
import { decryptData, encodeUTF, encryptData } from './CartUtils';
import { getCookieValue } from './commonUtils';
import { getScreenName } from './helper';

import { fireEvent } from './fireEvent';

export const updateLocalStorageDataForPayment = (paymentMode) => {
  const eventSHAData = localStorage.getItem('eventSHA');
  if (eventSHAData) {
    const decryptedData = decryptData(eventSHAData);
    const isDefaultData = Cookies.get('is_default');
    let data = JSON.parse(decryptedData);
    let addressData = isDefaultData ? JSON.parse(isDefaultData) : null;
    const modes = getPaymentModeForAddress(data, paymentMode);
    data['details']['orderDetails']['address_id'] = addressData?.id;
    data['details']['orderDetails']['phone'] = addressData?.mobile;
    const encryptedData = data ? encryptData(JSON.stringify(data)) : null;
    localStorage.setItem('eventSHA', encryptedData);
    localStorage.setItem('filter_key', modes);
    localStorage.setItem('from_next', true);
    return true;
  } else {
    fireEvent({
      category: 'error',
      name: 'Local Storage Not found',
      page_url: window.location.href,
      support_variable: 'Local Storage Not found',
      screen_name: getScreenName(),
    });
  }
};

export const getPaymentModeForAddress = (addressData, newPaymentMode) => {
  return addressData?.paymentOption === '0'
    ? newPaymentMode === true || newPaymentMode === '2'
      ? '2'
      : '0'
    : addressData?.paymentOption;
};

export function getAddressRequiredParam(cookiesString) {
  const param = {
    'web_user_id': null,
    'Mylo-In-App': false,
  };
  let user_logged_in = getCookieValue(cookiesString, 'token');
  if (!user_logged_in) {
    let web_user_id = getCookieValue(cookiesString, 'web_user_id_react');
    param['web_user_id'] = web_user_id;
  }
  return param;
}

export const getAddressDataCartOffUser = (addressRecoveryData) => {
  return {
    name: addressRecoveryData[0],
    mobile: addressRecoveryData[1],
    zipcode: addressRecoveryData[2],
    address_line_1: addressRecoveryData[3],
    address_line_2: addressRecoveryData[4],
    city: addressRecoveryData[5],
    state: addressRecoveryData[6],
  };
};
const addressFilterKeys = [
  'first_name',
  'last_name',
  'address_line1',
  'address_line2',
  'address',
  'address_type',
  'recipient_phone',
  'pincode',
  'city',
  'state',
  'country',
  'email',
];

export function getInitialFieldValue(addressForm) {
  for (let i = 0; i < addressForm.length; i++) {
    const field = addressForm[i];
    if (field.id == 'state') return field.value ? true : false;
  }
}

export const setDatForAddressRecovery = (address) => {
  const filtered_data = getFilteredData(address);
  // console.log("filtered_data", filtered_data, address);
  //Event to be fired
  // Cookie to be deleted
  // Cookies.remove(recoveryDataKey);
  return filtered_data;
};

const getFilteredData = (address) => {
  let data = [];
  // let newData = [];
  for (let key of addressFilterKeys) {
    //const fieldData = address.find((element) => element.id === key);
    if (address[key]) {
      // newData.push(encodeUTF(fieldData?.value));
      data[key] = encodeUTF(address[key]);
    } else {
      data[key] = '';
      // newData.push("");
    }
  }
  // console.log(newData.join("."));
  // console.log(newData);
  return data;
};

export const getDropOffDataPayment = (address) => {
  return addressFilterKeys.map((filterKey) => {
    return encodeUTF(address[filterKey]);
  });
};
